import { Provider, providerToScope } from "@p0security/shared/types/assessment";
import Link from "antd/lib/typography/Link";
import { PermissionIntegrationLogo } from "components/Integrations/IntegrationLogo";

export type SupportedProvider = (typeof SupportedProviders)[number];
const SupportedProviders = ["aws", "gcloud"] as const;
function isSupportedProvider(source: string): source is SupportedProvider {
  return SupportedProviders.includes(source as SupportedProvider);
}

export const KeyLink: React.FC<{
  projectId: string;
  serviceAccountId: string;
  keyId: string;
  source: Provider;
}> = ({ projectId, serviceAccountId, keyId, source }) => {
  const fixedSource = providerToScope(source);
  if (isSupportedProvider(fixedSource)) {
    const logo = PermissionIntegrationLogo[fixedSource];
    const urls: Record<SupportedProvider, string> = {
      gcloud: `https://console.cloud.google.com/iam-admin/serviceaccounts/details/${serviceAccountId}/keys?project=${projectId}`,
      aws: `https://console.aws.amazon.com/iam/home?#/users/${serviceAccountId}`,
    };

    return (
      <Link href={urls[fixedSource]} target="_blank" rel="noopener">
        {keyId}&nbsp;{logo}
      </Link>
    );
  }
  return <>{keyId}</>;
};
